module.exports = __webpack_public_path__ + "media/click_2.8b81c63b.wav";